/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Select } from "antd";
import {
  CrossIcon,
  NeedHelp,
  SelectArrow,
  TickIcon,
} from "../../../../atoms/CustomIcons";
import { useNavigate } from "react-router-dom";
import {
  FullCalendarEvent,
  SchedulingFormDataResponse,
} from "../../ducks/types";
import { useEffect, useState } from "react";

interface PropsType {
  schedulingFormData: SchedulingFormDataResponse | null;
  selectedCrewValue?: string;
  setSelectedCrewValue?: (value: string) => void;
  publishSchedule?: (events: any[]) => void;
  setCalendarEvents: React.Dispatch<React.SetStateAction<FullCalendarEvent[]>>;
  setVisitEvents: React.Dispatch<React.SetStateAction<FullCalendarEvent[]>>;
  setHoursData?: any;
  newChangesMade?: boolean;
  showChangesLeftPop?: React.Dispatch<React.SetStateAction<boolean>>;
  addChangesLeftFunc?: any;
}

export default function Header(props: PropsType) {
  const {
    schedulingFormData,
    selectedCrewValue,
    setSelectedCrewValue,
    setCalendarEvents,
    setVisitEvents,
    setHoursData,
    newChangesMade,
    showChangesLeftPop,
    addChangesLeftFunc,
  } = props;
  const navigate = useNavigate();
  const [crewOptions, setCrewOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];

  useEffect(() => {
    if (schedulingFormData) {
      // const crewDropOptions = Object.values(
      //   schedulingFormData?.workorders.reduce((acc: any, curr) => {
      //     if (!acc[curr.crew_or_contractor_name]) {
      //       acc[curr.crew_or_contractor_name] = {
      //         label: curr.crew_or_contractor_name,
      //         value: curr.crew_id, // first ID for that crew
      //       };
      //     }
      //     return acc;
      //   }, {})
      // ) as { label: string; value: string }[];

      const crewDropOptions = schedulingFormData?.crews.map((crew) => ({
        label: crew.name,
        value: crew.id,
      }));

      setCrewOptions(crewDropOptions);
    }
  }, [schedulingFormData]);

  // console.log("selectedCrewValue", selectedCrewValue);

  return (
    <div className="profileHeader">
      <div className="headerLeft">
        <Button
          size="large"
          icon={<CrossIcon />}
          onClick={() =>
            newChangesMade
              ? (showChangesLeftPop && showChangesLeftPop(true),
                addChangesLeftFunc({
                  nextBtn: false,
                  crossBtn: true,
                  prevBtn: false,
                  currentWeek: false,
                }))
              : navigate(`/scheduling/${companyId}`)
          }
        />
        <h2>Work scheduler</h2>
        <Select
          style={{ width: "200px" }}
          suffixIcon={<SelectArrow />}
          menuItemSelectedIcon={<TickIcon style={{ color: "#00A07D" }} />}
          showSearch
          // allowClear
          placeholder="Select crew"
          value={selectedCrewValue}
          options={crewOptions}
          onChange={(value) => {
            if (setSelectedCrewValue) {
              setSelectedCrewValue(value);
              setCalendarEvents([]);
              setVisitEvents([]);
            }
            if (setHoursData) {
              setHoursData([]);
            }
          }}
        />
      </div>
      <div className="header_btns_wrapper">
        <Button size="large" className="btn-sm" icon={<NeedHelp />}>
          Need help?
        </Button>
        {/* <Button size="large" className="outlined-btn">
          Discard changes
        </Button> */}
        {/* <Button
          size="large"
          className="mint-btn"
          onClick={() => {
            if (publishSchedule) {
              publishSchedule([]);
            }
          }}
        >
          Publish schedule
        </Button> */}
      </div>
    </div>
  );
}
